export const DataMaintenanceTypeDefault = { operations: [], models: [] };
